import { useContext, useEffect, useRef, useState } from "react";

import Form, { fetchParamsToFormValues } from "../Form";
import Results from "./Results";

import RefreshPage from "/src/components/common/Error/RefreshPage";
import Spinner from "/src/components/common/Spinner";

import { AppContext } from "/src/components/context/App";

import { fetchData } from "../fetchData.js";

import { are_params_equal, form_values_to_fetch_params, sanitise_params } from "/src/lib/http/index.js";

function Search({ defaultSearchParams, defaultSearchTaxonomy }) {

  const context = useContext(AppContext);

  const el = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const [formValues, setFormValues] = useState(fetchParamsToFormValues(defaultSearchParams));
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);

  const validateFormValues = (newFormValues) => {
    setFormValues(newFormValues);
  }

  const scrollToTop = () => {
    if (el.current && page > 1) {
      el.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  const fetch = async (formValues, pagingParams) => {
    const { per_page, ...otherParams } = form_values_to_fetch_params(sanitise_params(formValues));
    //
    setIsLoading(true);
    // Server
    const fetchParamsHook = context?.SEARCH_PARAMS_HOOK || (c => c);
    const wordpressParams = fetchParamsHook(otherParams); // Add operators LIKE, BETWEEN etc
    const res = await fetchData({
      ...context?.SEARCH_PARAMS, // API related
      ...pagingParams,
      ...(per_page != null && { per_page }),
      ...defaultSearchTaxonomy,
      filter: wordpressParams,
    });
    // Client
    // TODO?
    const searchResultsHook = context?.SEARCH_RESULTS_HOOK || (c => c);
    const finalRes = await searchResultsHook(res);
    setIsLoading(false);
    setResults(finalRes);
    scrollToTop();
  }

  const shouldSubmit = async (newFormValues, options={}) => {
    const { forceSubmit = false } = options;
    const paramsEqual = are_params_equal(formValues, newFormValues);
    if (forceSubmit === true || paramsEqual !== true) {
      fetch(newFormValues, {
        page: 1,
        max_page: 10,
      });
    }
  }

  useEffect(() => {
    const init = async () => {
      await shouldSubmit(formValues, { forceSubmit: true });
    }
    try {
      init();
    }
    catch (e) {
      setError(true);
    }
  }, []);

  if (isError) {
    return (
      <RefreshPage />
    );
  }

  return (
    <div ref={el} className="d-flex flex-column gap-0 position-relative">
      <Spinner isLoading={isLoading} />
      <Form formValues={formValues} setFormValues={validateFormValues} shouldSubmit={shouldSubmit} />
      <Results results={results} />
    </div>
  );

}

export default Search;
